module.exports = __webpack_public_path__ + "static/media/city-at-night.a468d011.jpg";